import React from 'react';

/**
 * PalletWheelPicker - Modal for selecting items from wheels to add to pallet
 */
const PalletWheelPicker = ({
  isOpen,
  onClose,
  wheels,
  wheelSearch,
  onWheelSearchChange,
  filteredWheels,
  selectedWheelId,
  onSelectWheel,
  selectedWheelItems,
  checkedWheelItems,
  onToggleWheelItem,
  onToggleAllWheelItems,
  loadingWheelItems,
  onPickItems,
  onBack
}) => {
  if (!isOpen) return null;

  const anyChecked = Object.values(checkedWheelItems).some(v => v);
  const allChecked = selectedWheelItems.length > 0 && selectedWheelItems.every((_, index) => checkedWheelItems[index]);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal wheel-picker-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Pick Items from Wheel</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          {/* Wheel Selection View */}
          {!selectedWheelId ? (
            <>
              <div className="wheel-search-box">
                <svg className="search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="11" cy="11" r="8"/>
                  <path d="M21 21l-4.35-4.35"/>
                </svg>
                <input
                  type="text"
                  placeholder="Search wheels..."
                  value={wheelSearch}
                  onChange={(e) => onWheelSearchChange(e.target.value)}
                />
              </div>
              {filteredWheels.length === 0 ? (
                <div className="no-wheels-message">
                  <p>No wheels available</p>
                </div>
              ) : (
                <div className="wheel-list">
                  {filteredWheels.map(wheel => (
                    <div
                      key={wheel.id}
                      className="wheel-list-item"
                      onClick={() => onSelectWheel(wheel.id)}
                    >
                      <div className="wheel-list-header">
                        <span className="wheel-list-number">{wheel.wheel_number}</span>
                        {wheel.is_full && (
                          <span className="full-badge">FULL</span>
                        )}
                        {wheel.label_text && (
                          <span className="pallet-label-badge" style={{ backgroundColor: wheel.label_color || '#757575' }}>
                            {wheel.label_text}
                          </span>
                        )}
                      </div>
                      <div className="wheel-list-details">
                        <span className="wheel-list-items">{wheel.item_count} items</span>
                        <span className="wheel-list-weight">{parseFloat(wheel.total_weight || 0).toFixed(2)} kg</span>
                      </div>
                      {wheel.item_names && (
                        <div className="wheel-list-contents">{wheel.item_names}</div>
                      )}
                      {wheel.customer_name && (
                        <div className="wheel-list-customer">Customer: {wheel.customer_name}</div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </>
          ) : (
            /* Item Selection View */
            <>
              <div className="wheel-items-header">
                <button className="back-to-wheels-btn" onClick={onBack}>
                  ← Back to wheels
                </button>
                <span className="selected-wheel-title">
                  {wheels.find(w => w.id === selectedWheelId)?.wheel_number}
                </span>
              </div>
              {loadingWheelItems ? (
                <div className="loading-wheel-items">Loading items...</div>
              ) : selectedWheelItems.length === 0 ? (
                <div className="no-wheels-message">
                  <p>No items in this wheel</p>
                </div>
              ) : (
                <>
                  <div className="select-all-row">
                    <label className="select-all-label">
                      <input
                        type="checkbox"
                        checked={allChecked}
                        onChange={(e) => onToggleAllWheelItems(e.target.checked)}
                      />
                      Select All ({selectedWheelItems.length} items)
                    </label>
                  </div>
                  <div className="wheel-items-list">
                    {selectedWheelItems.map((item, index) => (
                      <label key={index} className={`wheel-item-row ${checkedWheelItems[index] ? 'checked' : ''}`}>
                        <input
                          type="checkbox"
                          checked={checkedWheelItems[index] || false}
                          onChange={() => onToggleWheelItem(index)}
                        />
                        <div className="wheel-item-info">
                          <div className="wheel-item-name">
                            <span className="wheel-item-part">{item.part_number}</span>
                            {item.name}
                          </div>
                          <div className="wheel-item-details">
                            <span>Qty: {item.quantity}</span>
                            <span>Lot: {item.lot_number}</span>
                            <span>{parseFloat(item.subtotal_weight || 0).toFixed(2)} kg</span>
                          </div>
                        </div>
                      </label>
                    ))}
                  </div>
                </>
              )}
            </>
          )}
        </div>
        <div className="modal-footer">
          <button className="modal-btn close" onClick={onClose}>
            Cancel
          </button>
          {selectedWheelId && selectedWheelItems.length > 0 && (
            <button
              className="modal-btn save"
              onClick={onPickItems}
              disabled={!anyChecked}
            >
              Add Selected Items
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PalletWheelPicker;
